module.exports = __webpack_public_path__ + "assets/img/banner4.436273be.png";